import { none } from './special-projections/none';
import { solid } from './special-projections/solid';
import { source } from './special-projections/source';
import { calibrationGrid, calibrationGridInverted } from './test-projections/calibration-grid';
import { checkerboard } from './test-projections/checkerboard';
import { colorBars } from './test-projections/color-bars';
import { colorGrid } from './test-projections/color-grid';
import { colorbars } from './test-projections/colorbars';
import { crosshatch } from './test-projections/crosshatch';
import { focusRings } from './test-projections/focus-rings';
import { testCard } from './test-projections/test-card';
import type { InputSource } from './types';

export type { InputSource } from './types';

export const inputSources: Record<string, InputSource> = {
  solid,
  none,
  source,
  checkerboard,
  colorBars,
  focusRings,
  calibrationGrid,
  calibrationGridInverted,
  colorGrid,
  colorbars,
  crosshatch,
  testCard,
};

// Map old value keys to new names for scenes saved with legacy values
export const legacyNameMap: Record<string, string> = {
  grid1: 'calibrationGrid',
  grid1inverted: 'calibrationGridInverted',
  grid2: 'colorGrid',
};

export function resolveInputSource(name: string): InputSource {
  const resolved = legacyNameMap[name] || name;
  return inputSources[resolved] || inputSources['calibrationGrid'];
}
